import {evite} from 'evite';
import EmptyEvent from '~/fixtures/events/empty';
import EmptyTemplate from '~/fixtures/templates/empty';
import BookShelf from '~/fixtures/templates/bookshelf';
import {createStore as originalCreateStore} from '~/create/stores/index';

window.category_list = [
  [
    {
      displayName: 'Mardi Gras',
      categoryId: 'mardi_gras',
      eventType: 'mardi_gras',
      visible: true,
    },
    {
      displayName: 'Soccer',
      categoryId: 'soccer',
      eventType: 'soccer',
      visible: true,
    },
  ],
];

export function createStore({event, template, changeDesign} = {}) {
  evite.constants = {};
  evite.constants.TEMPLATE = BookShelf.toJSON();

  changeDesign = {
    replaceBrowserHistory: (url) => {},
    ...changeDesign,
  };
  return originalCreateStore({
    changeDesign,
    event: event || EmptyEvent.toJSON(),
    template: template || EmptyTemplate.toJSON(),
  });
}
